import { TextView } from '../../ui_canvas_engine/TextView.ts';
import { SpriteView } from '../../ui_canvas_engine/SpriteView.ts';
import { GameColor } from '@colonist/ui-game';
import { Sprites } from '../UIGameImageDictionary.ts';
import { UIGameSpriteHandler } from '../../UIGameSpriteHandler.ts';
import { GameFont } from '../../GameFont.ts';
export class UIGameCardCountBadgeView {
    createCardCountText(cardCount) {
        const x = this.cardView.view.width * 0.78;
        const y = this.cardView.view.height * -0.02;
        const width = this.badgeBackground.width;
        const colorDarkGrey = GameColor.getColor(GameColor.Color.DarkGrey);
        const colorOffWhite = GameColor.getColor(GameColor.Color.OffWhite);
        const countText = {
            key: 'strings:colonistCommon.utils.#buffer',
            options: {
                value: cardCount
            }
        };
        this.countTextView = new TextView(countText, x, y, width, width, this.cardView, GameFont.Size.Normal, colorOffWhite, false);
        const fontSize = this.cardView.view.height * 0.25;
        this.countTextView.makeBold();
        this.countTextView.changeStyle({
            stroke: colorDarkGrey,
            strokeThickness: 2,
            fontSize: fontSize
        });
        this.countTextView.anchor.set(0.5, 0);
        this.updateText(cardCount);
    }
    updateText(cardCount) {
        const countText = {
            key: 'strings:colonistCommon.utils.#buffer',
            options: {
                value: cardCount
            }
        };
        this.countTextView.setText(countText);
    }
    hideBadge() {
        if (this.badgeBackground.parent != undefined) this.badgeBackground.parent.removeChild(this.badgeBackground);
        if (this.countTextView.parent != undefined) this.countTextView.parent.removeChild(this.countTextView);
    }
    showBadge() {
        if (this.badgeBackground.parent == undefined) this.cardView.addChild(this.badgeBackground);
        if (this.countTextView.parent == undefined) this.cardView.addChild(this.countTextView);
    }
    fadeOutBadge() {
        this.badgeBackground.tint = GameColor.getColorHexValue(GameColor.Color.CardViewFadedTint);
        this.countTextView.resetCache(()=>this.countTextView.tint = GameColor.getColorHexValue(GameColor.Color.CardViewFadedTint));
    }
    fadeInBadge() {
        this.badgeBackground.tint = GameColor.getColorHexValue(GameColor.Color.White);
        this.countTextView.resetCache(()=>this.countTextView.tint = GameColor.getColorHexValue(GameColor.Color.White));
    }
    constructor(cardCount, cardView){
        this.cardView = cardView;
        const size = this.cardView.view.height / 3;
        const badgeOverflowCorrection = this.cardView.view.width * 0.02;
        const x = this.cardView.view.width - size - badgeOverflowCorrection;
        this.badgeBackground = new SpriteView(x, 0, size, size, this.cardView, UIGameSpriteHandler.getTextureFromSpritesheet(Sprites.card_badge_background));
        this.createCardCountText(cardCount);
    }
}
